import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function AlertDialog({
  id,
  action,
  index,
  dialogTitle,
  dialogContentText,
  children,
  color = 'red',
  disabled = false,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (event) => {
    event.stopPropagation();
    if (disabled) return;
    setOpen(true);
  };

  const disabledStyle = disabled
    ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'auto' }
    : null;

  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  return (
    <React.Fragment>
      {children ? (
        <div onClick={handleClickOpen} style={disabledStyle}>{children}</div>
      ) : color === 'red' ? (
        <img
          src={`${process.env.PUBLIC_URL}/delete.svg`}
          alt="delete"
          style={{ cursor: 'pointer', ...(disabledStyle || {}) }}
          onClick={handleClickOpen}
        />
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/delete-blue.svg`}
          alt="delete"
          height={22}
          className="detail-icon clickable"
          style={disabledStyle || undefined}
          onClick={handleClickOpen}
        />
      )}

      <Dialog
        open={open}
        onClick={(event) => event.stopPropagation()}
        onClose={handleClose}
        keepMounted
        disableAutoFocus
        disableEnforceFocus
        disableScrollLock
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{dialogContentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ color: '#1976d2' }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{ color: '#1976d2' }}
            //onClick={() => action(id, index)}
            onClick={async (event) => {
              event.stopPropagation();
              await action(id, index);
              setOpen(false);
            }}
            autoFocus
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default React.memo(AlertDialog);
